async function getItems() {
  try {
    const res = await window.axios.get('/api/v1/admin/shop');
    const items = res.data;
    const skins = items.filter(a => a.itemKind == 'Skin').sort((a, b) => a.order - b.order);
    const formations = items.filter(a => a.itemKind == 'Formation').sort((a, b) => a.order - b.order);
    const chats = items.filter(a => a.itemKind == 'Chat').sort((a, b) => a.order - b.order);
    const avatars = items.filter(a => a.itemKind == 'Avatar').sort((a, b) => a.order - b.order);
    const coins = items.filter(a => a.itemKind == 'coin').sort((a, b) => a.order - b.order);
    const tickets = items.filter(a => a.itemKind == 'ticket').sort((a, b) => a.order - b.order);
    const result = [
      {
        itemType: 'Skin',
        itemName: 'مهره',
        items: skins,
      },
      {
        itemType: 'Formation',
        itemName: 'ترکیب',
        items: formations,
      },
      {
        itemType: 'Chat',
        itemName: 'ایموجی',
        items: chats,
      },
      {
        itemType: 'Avatar',
        itemName: 'اواتار',
        items: avatars,
      },
      {
        itemType: 'coin',
        itemName: 'سکه',
        items: coins,
      },
      {
        itemType: 'ticket',
        itemName: 'بلیط',
        items: tickets,
      },
    ];
    return result;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

async function getRawItems() {
  try {
    const res = await window.axios.get('/api/v1/admin/shop');
    return res.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

async function updateItem(params) {
  try {
    const res = await window.axios.put('/api/v1/admin/shop', params);
    return res.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

async function deleteItem(params) {
  const res = await window.axios.delete(`/api/v1/admin/shop?_id=${params._id}`);
  return res.data;
}

async function addItem(params) {
  try {
    const res = await window.axios.post('/api/v1/admin/shop', params);
    return res.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

async function getItem(id) {
  try {
    const res = await window.axios.get('/api/v1/admin/shop/detail', { params: { _id: id } });
    return res.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

async function avatars() {
  try {
    const res = await window.axios.get('/api/v1/admin/avatar/all');
    return res.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

async function skins() {
  try {
    const res = await window.axios.get('/api/v1/admin/skin/all');
    return res.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}
async function formations() {
  try {
    const res = await window.axios.get('/api/v1/admin/formation/all');
    return res.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}
async function chats() {
  try {
    const res = await window.axios.get('/api/v1/admin/chat/all');
    return res.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

module.exports = { getItems, getRawItems, addItem, updateItem, getItem, avatars, skins, formations, chats, deleteItem };
